export function getImageUrl(imageUrl, mobileImageUrl, isMobile) {
  return (isMobile && mobileImageUrl) || imageUrl;
}
